import React from 'react'
import { useLocation } from 'react-router-dom'
import { PageLayout } from 'app/views/components/layout/page-layout'
import PageTitle from 'app/views/components/Headers&Text/PageTitle'
import { PortfoliosAndStrategiesDrillPage } from './portfolios-and-strategies-drill-page'
import { capitalizeFirstLetter } from 'app/utils/util-functions'

export default function PortfoliosAndStrategiesPage() {
    const location = useLocation()
    const tab = location.pathname === '/portfolioandstrategy/strategy' ? 'strategy' : 'portfolio'
    return (
        <PageLayout>
            <PageTitle pageTitle={capitalizeFirstLetter(tab)} />
            <PortfoliosAndStrategiesDrillPage />
        </PageLayout>
    )
}
